// Search configuration constants
export const MIN_SEARCH_CHARS = 3
export const SEARCH_DEBOUNCE_MS = 500

// Simple type mapping for First Bite results
export const TYPE_MAPPING: Record<string, string> = {
  RE: 'Restaurants',
  HO: 'Hospitals',
  DI: 'K-12 Schools',
  CU: 'College and University',
  NH: 'Senior Living',
  LG: 'Lodging',
  CS: 'Convenience Stores',
}

export const SORT_OPTIONS = [
  { value: 'relevance', label: 'Relevancy' },
  { value: 'alphabetical_asc', label: 'Alphabetical (A-Z)' },
  { value: 'alphabetical_desc', label: 'Alphabetical (Z-A)' },
  { value: 'size_desc', label: 'Company Size (Large to Small)' },
  { value: 'size_asc', label: 'Company Size (Small to Large)' },
]

export interface Filters {
  category: string
  type: string
  product: string // Product filter for variants tab
}

// Tab type for unified search
export type UnifiedSearchTab =
  | 'mycompanies'
  | 'firstbite'
  | 'unmatched'
  | 'firstbitedoors'
  | 'unmatcheddoors'
  | 'variants'
  | 'deals'
